// src/components/ui/tabs.js - Tabs 컴포넌트
import React, { createContext, useContext } from 'react';

// Tabs Context
const TabsContext = createContext();

// Tabs Container
export const Tabs = ({ 
  value, 
  onValueChange, 
  children, 
  className = "" 
}) => {
  return (
    <TabsContext.Provider value={{ value, onValueChange }}>
      <div className={className}>
        {children}
      </div>
    </TabsContext.Provider>
  );
};

// Tabs List (탭 헤더들)
export const TabsList = ({ 
  children, 
  className = "" 
}) => {
  return (
    <div className={`inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground ${className}`}>
      {children}
    </div>
  );
};

// Tab Trigger (개별 탭 버튼)
export const TabsTrigger = ({ 
  value, 
  children, 
  className = "",
  disabled = false
}) => {
  const context = useContext(TabsContext);
  
  if (!context) {
    throw new Error('TabsTrigger must be used within Tabs');
  }

  const { value: selectedValue, onValueChange } = context;
  const isSelected = selectedValue === value;

  const handleClick = () => {
    if (!disabled && onValueChange) {
      onValueChange(value);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 
        text-sm font-medium ring-offset-background transition-all 
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 
        disabled:pointer-events-none disabled:opacity-50
        ${isSelected 
          ? 'bg-background text-foreground shadow-sm' 
          : 'hover:bg-background/50 hover:text-foreground'
        }
        ${className}
      `}
    >
      {children}
    </button>
  );
};

// Tab Content (탭 내용)
export const TabsContent = ({ 
  value, 
  children, 
  className = "" 
}) => {
  const context = useContext(TabsContext);
  
  if (!context) {
    throw new Error('TabsContent must be used within Tabs');
  }

  const { value: selectedValue } = context;
  
  if (selectedValue !== value) {
    return null;
  }

  return (
    <div className={`mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${className}`}>
      {children}
    </div>
  );
};